import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ModalVariables, Table, TableSkeleton, TopProgress, Typography } from "../../../../components";
import { useAuth } from "../../../../context/user.context";
import { icons } from "../../../../icons";
import {Container} from './styles'
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { useNavigate, useParams } from "react-router-dom";
import { useUi } from "../../../../context/ui.context";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { openstackPlanService } from "../../../../api";

const OpenstackPlanPage:FC = () => {
  const [rows, setRows] = useState<any[]>([])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const {viewAlert} = useUi()
  const [data, setData] = useState<any>()
  const [t] = useTranslation()
  const {planId, ruleId} = useParams()

  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [selectedPricingRule, setSelectedPricingRule] = useState<any>()
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModal = async () => {
    if (modalType !== 'delete') return

    try {
      setLoading(true);
      if (selectedPricingRule) {
        const res = await openstackPlanService.deletePriceRule(selectedPricingRule.id);
        viewAlert({
          severity: 'info',
          message: res?.data?.detail || t("PRICING_RULE_DELETED"),
        });
        await updateList()
      } else if (planId) {
        const res = await openstackPlanService.deletePlanById(planId);
        viewAlert({
          severity: 'info',
          message: res?.data?.detail || t("PRICING_PLAN_DELETED"),
        });
      } else {
        return
      }
      closeModalCancel()
      if (!selectedPricingRule) {
        navigate('/settings/openstack-plans')
      }
    } catch (e: any) {
      viewAlert({
        severity: 'error',
        message: e?.response?.data?.detail || t("ERROR_OCCURRED"),
      });
    } finally {
      setLoading(false);
    }
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
    setSelectedPricingRule(undefined)
  }
      
  const updateList = async () => {
    if(!planId) return
    try{
      const res = await openstackPlanService.getPlanById(planId)
      let data = res.data.pricing_rules.map((rule:any) => {
        return {
        ...rule,
        price:`${rule?.price} ${res?.data?.currency} / ${rule?.display_unit}`,
      }})
      setRows(data)
      setData(res.data);
      setPageLoading(false)

    } catch(e:any){
      if(e?.response?.data?.detail){
        viewAlert({
          severity:'error',
          message:e?.response?.data?.detail
        })
      }
      setPageLoading(true)

    }
    
  }
  const navigate = useNavigate()
  useEffect(() => {
    updateList()
    const interval = setInterval(() => {
    updateList()

    },10000)
    return () => clearInterval(interval)
  },[])
  const items = [
    {
      title:t("EDIT"),
      id:'2',
      icon:icons.Edit,
      onClick: (item:any) => navigate(`/settings/openstack-plans/rule/${item.id}/edit`),
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(pricingRule:any) => {
        setSelectedPricingRule(pricingRule)
        setAlertTitle(t("PRICING_RULE"))
        setAlertSubTitle([{
          name: pricingRule.display_name || pricingRule.id,
        }])
        openModal('delete')
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const columns = [
    {
      title:t("NAME"),
      key:"display_name"
    },
    {
      title:t("RESOURCE"),
      key:'resource_name'
    },
    {
      title:t("PRICE"),
      key:"price",
    },
    {
      title:"",
      key:'props'
    }
  ]
  
  return(
    <Container>
      <div style={{display:'flex', gap:'10px', alignItems:'center', justifyContent:'space-between'}}>
        <Typography variant="h3">{t("OPENSTACK_PLAN")} <span>{data?.name}</span></Typography>
        <div style={{display:'flex', gap:'10px'}}>
          <Button
            title={t("CREATE_PRICING_RULE")}
            onClick={() => {
              navigate(`/settings/openstack-plans/plan/${planId}/create-rule`)
            }}
            test_id='button-delete'
            variant='primary'
            size='display'
          />
           
          <Button
            onClick={() => {
              navigate(`/settings/openstack-plans/plan/${planId}/edit`)
            }}
            test_id='button-delete'
            variant='icon'
            size='display'
          >
            <img src={icons.Edit}/>
          </Button>

          <Button
            onClick={() => {
              setSelectedPricingRule(undefined)
              setAlertTitle(t("PRICING_PLAN"))
              setAlertSubTitle([{ name: data?.name || planId }])
              openModal('delete')
            }}
            test_id='button-delete'
            variant='icon'
            size='display'
          >
            <img src={icons.DeleteIcon}/>
          </Button>
        </div>
      </div>
      {pageLoading ?
        <TableSkeleton
            rows={10}
            columns={columns?.length || 5}
            columnsData={columns}
          />
      :
        <Table
          columns={columns}
          rows={rows}
          hideCheckbox
          settings={items}
          updateData={updateList}
          loading={pageLoading}
        />
      }
      <ModalVariables
        id={planId}
        modalType={modalType}
        closeModalCancel={closeModalCancel}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
      />
    </Container>
  )
}

export default OpenstackPlanPage
